// extracted by mini-css-extract-plugin
module.exports = {"container":"qFFilzvg","cellWrapper":"ZTlZaXme","cellInner":"i8tYFhRP","wrapper":"W52X65yq","styledTanStackTableRoot":"BPP34Xwk","buttonWrapper":"bV8Aq34Q"};